/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type RedelegateQuestionnaire = {
  delegation_id: number;
  delegatee_email: string;
  delegatee_name: string;
  notification_preference?: RedelegateQuestionnaire.notification_preference;
};
export namespace RedelegateQuestionnaire {
  export enum notification_preference {
    EACH_ANSWER = 'each_answer',
    ALL_COMPLETE = 'all_complete',
    NONE = 'none',
  }
}

